export const CHIEF_ROLES = ["AV1", "AV-A1", "AV-B1", "TV1", "EXE1", "C"] as const;

export type ChiefRole = (typeof CHIEF_ROLES)[number];
